import { Badge } from "react-bootstrap"
import { ucFirst } from "./generic_functions"
import { Border } from "react-bootstrap-icons"

export function displayTriangle(question, resolvedLanguage) {
  return question["statement" + ucFirst(resolvedLanguage)].split("|").map((statement, index) => {
    const size = 30
    const A = { x: 50, y: 35 }
    const height = Math.round((Math.sqrt(5) / 2) * size)
    const textOffset = 10
    const badgeWidth = 30
    let values = statement.split(";")

    const points = [
      { x: A.x, y: A.y, labelX: A.x - badgeWidth / 2, labelY: A.y - textOffset - 30 / 1.5, value: values[0] },
      { x: A.x - size / 1.5, y: A.y + height, labelX: A.x - size / 1.5 - textOffset - badgeWidth / 2, labelY: A.y + height + textOffset, value: values[1] },
      { x: A.x + size / 1.5, y: A.y + height, labelX: A.x + size / 1.5 + textOffset - badgeWidth / 2, labelY: A.y + height + textOffset, value: values[2] },
    ]

    let polygonPoints = points.map((point) => `${point.x},${point.y}`).join(" ")
    return (
      <svg width="100" height="100" style={{ border: "0px solid white" }}>
        <polygon points={polygonPoints} fill="transparent" stroke="white" strokeWidth="1" />
        {points.map((point, index) => {
          let background = "black"
          let text = "white"
          if (point.value === "?") {
            background = "warning"
            text = "black"
          }

          return (
            <foreignObject key={index} x={point.labelX} y={point.labelY} width={badgeWidth} height={size}>
              <Badge key={"statement_" + question.id + "_" + index} bg={background} className={"text-" + text} style={{ display: "block", textAlign: "center", color: "white" }}>
                {point.value}
              </Badge>
            </foreignObject>
          )
        })}
      </svg>
    )
  })
}

export function displaySquare(question, resolvedLanguage) {
  return question["statement" + ucFirst(resolvedLanguage)].split("|").map((statement, index) => {
    const size = 30
    const A = { x: 30, y: 50 }
    const textOffset = 10
    const badgeWidth = 30
    let values = statement.split(";")

    const points = [
      { x: (90 - size) / 2, y: A.y - size / 2, labelX: A.x - size / 2 - badgeWidth / 2, labelY: A.y - size / 2 - textOffset - 30 / 1.5, value: values[0] },
      { x: (90 + size) / 2, y: A.y - size / 2, labelX: A.x + size / 2 + textOffset, labelY: A.y - size / 2 - textOffset - 30 / 1.5, value: values[1] },
      { x: (90 + size) / 2, y: A.y + size / 2, labelX: A.x + size / 2 + textOffset, labelY: A.y + size / 2 + textOffset, value: values[2] },
      { x: (90 - size) / 2, y: A.y + size / 2, labelX: A.x - size / 2 - badgeWidth / 2, labelY: A.y + size / 2 + textOffset, value: values[3] },
    ]

    let polygonPoints = points.map((point) => `${point.x},${point.y}`).join(" ")
    return (
      <svg width="100" height="100" style={{ border: "0px solid white" }}>
        <polygon points={polygonPoints} fill="transparent" stroke="white" strokeWidth="1" />
        {points.map((point, index) => {
          let background = "black"
          let text = "white"
          if (point.value === "?") {
            background = "warning"
            text = "black"
          }

          return (
            <foreignObject key={index} x={point.labelX} y={point.labelY} width={badgeWidth} height="30">
              <Badge key={"statement_" + question.id + "_" + index} bg={background} className={"text-" + text} style={{ display: "block", textAlign: "center", color: "white" }}>
                {point.value}
              </Badge>
            </foreignObject>
          )
        })}
      </svg>
    )
  })
}
